import lazyGettext from 'js-utils/lazy-gettext';

export const LIVE_STATUS = lazyGettext('LIVE');
export const POSTPONED_STATUS = lazyGettext('POSTPONED');
